<template>
  <div class="menuBody" >
    <div class="menuTool" style="width:100%;">
        <pollingTree @pollingTree="getMsgFormSon" />
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                巡检点位统计列表
            </div>
               <div style="width:150px;float:left;margin-right:15px">
                <el-select  clearable v-model="value" size="small" @change="classificationChange(value)" placeholder="请选择巡检分类">
                  <el-option
                    v-for="item in classificationList"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div style="width:150px;float:left;margin-right:15px">
                 <el-input placeholder="请输入点位编码" size="small"    v-model="spotCode"></el-input>
              </div>
              <div style="width:150px;float:left;margin-right:15px">
                    <el-date-picker
                        v-model="value1"
                        type="daterange"
                        size="small"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="TimeChange(value1)">
                    </el-date-picker>
              </div>
            <div style="float:right;margin-right:15px;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" @click="Inquire()">查询</el-button>
            </div>
    <el-table  :data="tableData" tooltip-effect="light"   v-loading="loading"  style="margin-bottom: 20px;overflow-y: scroll;float:right;margin-top:30px" row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
        <el-table-column show-overflow-tooltip prop="projectName" label="所属项目"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="inspectType"   label="巡检分类"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="spotName"    label="点位名称" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="spotCode"    label="点位编码" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="location"    label="位置" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="shouldInspect"    label="应巡查次数"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="inspectNum"      label="实际巡查次数"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="dongingNum"   label="进行中次数" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="incomplete"   label="未巡查次数" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="timely"   label="巡查及时率" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="exceptionNum"   label="异常次数" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="exception"   label="点位异常率" ></el-table-column>
    </el-table> 
          <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import pollingTree from "../pollingCommon/pollingTree.vue";
export default {
  name: "PointStatistical",
  components: {pollingTree},
  data() {
    return {
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        loading:false,
        tableData:[],
        value:"",
        value1:"",
        staff:"",
        spotCode:"",
        classificationList:[],
        inspectTypeName:"",
    }
  },
  methods: {
    handleSizeChange(val) {
        this.pagesize  = val
        this.InitialQuery()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.InitialQuery()
    },
    InitialQuery(){
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "inspectType":"",
        "spotCode":"",
        "startDate":"",
        "endDate":"",
        "orgId":this.orgId,
      }
    this.$http.post(this.$requestUrl.POST_TOTAL_LIST,PageSize).then((res) => {
      let data = res.data
      if(data.code == 200){
        this.tableData = data.data.records
        this.total = data.data.total
      }else{
         this.$message.error(data.msg)
      }
    }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
    })
    },
    Inquire(){
    // 查询
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "startDate":this.startDate,
        "endDate":this.endDate,
        "inspectType":this.inspectTypeName,
        "spotCode":this.spotCode,
        "orgId":this.orgId,
      }
    this.$http.post(this.$requestUrl.POST_TOTAL_LIST,PageSize).then((res) => {
      let data = res.data
      if(data.code == 200){
        this.tableData = data.data.records
        this.total = data.data.total
      }else{
         this.$message.error(data.msg)
      }
    }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
    })
    },
    classificationChange(res){
      for(let val of this.classificationList){
        if(val.id == res){
          this.inspectTypeName = val.typeName
        }
      }
    },
    classification(){
      this.$http.get("/inspect/type/select").then((res)=>{
      let data = res.data
      if(data.code == 200){
        this.classificationList = res.data.data
      }else{
         this.$message.error(data.msg)
      }
      })
    },
    DutyCycleChange(res){
    },
    period(){
     this.$http.get("/inspect/project/getRate").then((res)=>{
      let data = res.data
      if(data.code == 200){
        var words = res.data.data
        var result = Object.keys(words).map(e => ({value: e, label: words[e]}))
        this.DutyCycleList = result
      }else{
        this.$message.error(data.msg)
      }
      })
    },
    TimeChange(date){
      this.getDate(date)
    },
    getDate(res){
	    	let date = res[0];
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
        let time = year+"-"+month+"-"+dates
        this.startDate = time
        let datea = res[1];
	    	let yeara = datea.getFullYear();
	    	let montha = datea.getMonth() + 1 < 10 ? '0' + (datea.getMonth() + 1 ): datea.getMonth() + 1
	    	let datesa = datea.getDate()< 10 ? '0' +datea.getDate() : datea.getDate()
        let timea = yeara+"-"+montha+"-"+datesa
        this.endDate = timea
	    },
    getMsgFormSon(data){
             if(data.orgId == null){
        this.orgId = data.id
      }else{
        this.orgId = data.orgId
      }
        this.InitialQuery()
    },
  },
  mounted() {
      this.classification()
      this.period()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
</style>